module.exports = __webpack_public_path__ + "static/media/Neo_Sans.2a25c884.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/Content/Assets/fonts/Neo_Sans.ttf
// module id = 648
// module chunks = 0